var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroFonce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 147,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M138.837 73.522c-.352 39.41-21.487 71.444-58.915 72.177l-10.691-.095C31.01 145.265.295 112.637.65 72.694 1.008 32.62 32.035.408 70.257.615l10.156.09c36.873 1.658 58.773 33.676 58.425 72.685l-.001.133Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M82.057 146.384c38.221.34 69.381-31.872 69.738-71.947.358-40.075-30.357-72.836-68.444-73.174C45.264.925 13.971 33.135 13.613 73.21c-.357 40.075 30.357 72.836 68.444 73.174Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M82.071 144.519c37.152.33 67.637-31.089 67.984-70.099.348-39.01-29.571-70.965-66.723-71.295-37.151-.33-67.636 31.09-67.984 70.1C15 112.233 44.92 144.188 82.07 144.518Z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M82.095 142.389c36.083.321 65.623-30.041 65.961-67.986.338-37.945-28.655-68.827-64.738-69.147-36.082-.32-65.622 30.042-65.96 67.986-.339 37.945 28.655 68.827 64.737 69.147Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M80.77 140.912c35.28.313 64.28-29.521 64.611-66.534.33-37.012-28.001-67.355-63.415-67.67-35.414-.314-64.281 29.521-64.611 66.534-.33 37.012 28 67.356 63.414 67.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m109.627 96.828 2.032 11.869c-7.116 3.665-16.363 6.512-26.119 6.425-21.382-.19-34.11-11.621-37.964-29.097l-12.562-.112 3.139-7.295 8.42.075c-.12-1.6-.237-3.464-.222-5.195.012-1.332.024-2.663.168-3.86l-9.889-.088 3.138-7.162 8.018.071c4.57-17.934 19.647-30.05 39.56-29.874 9.087.081 17.753 2.422 24.805 5.946l-2.516 12.36-.668-.005c-6.508-4.585-13.705-6.78-21.456-6.848-12.028-.107-20.11 7.011-23.287 18.567l36.349.323-2.87 7.164-34.746-.308c-.144 1.197-.156 2.528-.168 3.86-.016 1.73.101 3.596.22 5.194l32.074.285-2.738 7.3-28.198-.251c2.71 10.809 9.869 17.397 22.564 17.51 6.95.061 15.122-2.13 22.113-6.728l.668.006.135-.132Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD05C",
    d: "M64.942 71.786c-4.798-16.42 13.082-28.112 10.446-47.31-1.127-8.398-5.877-15.363-11.707-21.007-27.875 8.673-48.304 36.454-48.6 69.605-.36 40.208 29.419 72.961 66.17 73.154 9.087.081 17.658-1.841 25.574-5.366-.994-23.31-7.693-36.418-14.838-44.47C80.87 84.177 68.574 84.2 64.944 71.652l-.002.134Z",
    opacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 271.444,
    x2: -53.502,
    y1: 130.356,
    y2: 35.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6D13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 111.818,
    x2: -28.163,
    y1: 31.341,
    y2: 237.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 118.419,
    x2: 76.546,
    y1: 25.14,
    y2: 82.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C57E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 40.303,
    x2: 101.347,
    y1: -41.861,
    y2: 125.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.458,
    x2: 126.924,
    y1: 287.188,
    y2: -47.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 35.393,
    x2: 112.101,
    y1: 73.4,
    y2: 74.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCD91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroFonce);
export default __webpack_public_path__ + "static/media/euroFonce.182c410a18133f21cdfe79b2d20a567a.svg";
export { ForwardRef as ReactComponent };